import { render, staticRenderFns } from "./PageInfoTab.vue?vue&type=template&id=0a518aee&lang=pug"
import script from "./PageInfoTab.vue?vue&type=script&lang=js"
export * from "./PageInfoTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports